<script>
  import { afterUpdate, onMount } from "svelte";
  import { usePageContext } from "../../../components/pages/pageContext.js";
  import OrderTableMenuBar from "./OrderTableMenuBar.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import Table from "../../../components/table/Table.svelte";
  import TableHeader from "../../../components/table/TableHeader.svelte";
  import TableBody from "../../../components/table/TableBody.svelte";
  import TableRow from "../../../components/table/TableRow.svelte";
  import TableCell from "../../../components/table/TableCell.svelte";
  import TableHeaderCell from "../../../components/table/TableHeaderCell.svelte";

  /**
   * @type {string}
   */
  export let projectId

  /**
   * @type {{id: string}}
   */
  export let user

  export let styles
  export let ordersData
  export let OrderTableStore

  const {
    ItemsPerPage,
  } = OrderTableStore

  const { setHeaderProps } = usePageContext();
  $: setHeaderProps({ title: translate("mySchedule.views.orderTable.name") });
  $: setHeaderProps({ uploadTime: UploadTimeStamp});

  $: availableStyles = styles?.map(style => ({name: style[0], index: style[1]})) ?? []

  let UploadTimeStamp = null;

  // page internal states
  let currentPageIndex = null
  let totalNumberOfPages = 1

  $: displayedOrders = filterOrdersToBeDisplayed(ordersData?.[1], $ItemsPerPage, currentPageIndex)
  $: totalNumberOfPages = Math.floor((ordersData?.[1] ?? []).length / $ItemsPerPage) + 1

  function filterOrdersToBeDisplayed(ordersData, itemPerPage, currentPageIndex) {
    return ordersData?.filter((_, index) => {
      return currentPageIndex * itemPerPage <= index && index <= (currentPageIndex + 1) * itemPerPage - 1
    }) ?? []
  }

  $: displayedHeaderKeys = ordersData?.[3]?.filter(key => key !== "MyScheReservedFixedProperty") ?? []
  $: headerDict = Object.fromEntries(ordersData?.[3]?.map((header, i) => [header, ordersData?.[2][i]]) ?? [])
</script>

<div class="content-root">
  <OrderTableMenuBar
    totalPageNumber={totalNumberOfPages}
    styles={availableStyles}
    bind:currentIndex={currentPageIndex}
    userId={user.id}
    projectId={projectId}
    {OrderTableStore}
  />

  <div class="table-wrapper">
    <!-- Main Table -->
      {#if displayedOrders.length > 0}
        <Table type="wide">
          <TableHeader>
            {#each displayedHeaderKeys as key}
              <TableHeaderCell>{headerDict[key]}</TableHeaderCell>
            {/each}
          </TableHeader>
          <TableBody>
            {#each displayedOrders as order, i}
              <TableRow id={`row-${i}`}>
                {#each displayedHeaderKeys as headerKey, j}
                  <TableCell>{order[headerKey]}</TableCell>
                {/each}
              </TableRow>
            {/each}
          </TableBody>
        </Table>
      {:else}
        <p>{translate("frontend:views.orderTable.noOrder")}</p>
      {/if}
  </div>
</div>

<style>
  .content-root {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
  }

  .table-wrapper {
    display: flex;
    justify-content: center;
    background-color: white;
    height: 100%;
    overflow-y: auto;
  }
</style>
